<template>
    <div id="report">
        <Topbar v-if="this.$store.state.topbar_actions_visible" @applyFilters="top_filters" @export="fnExport" ></Topbar>
        <EventTeamsResume v-if="on_event_teams" :info="info_event_teams" :group="group_selected"></EventTeamsResume>

        <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
                <v-flex xs12>
                    <img src="/img/mic_image_1.png"/>
                </v-flex>
                <v-flex xs12>
                    <img src="/img/mic_image_2.png"/>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import EventTeamsResume from '@/components/ui/EventTeamsResume'
    import Topbar from '@/components/ui/Topbar';
    import {Api} from '@/core/api.js';
    const api = new Api();

    import i18n from '@/i18n'

    export default {
        name: 'ReportView',
        components: { Topbar, EventTeamsResume },
        props: { page: String, action: String },
        data() {
            return {
            }
        },
        computed: {
            on_event_teams() {
                if( this.page == 'event_teams' ){
                    this.$store.commit( 'setMenuVisible', true );
                    this.$store.commit( 'setTopFiltersVisible', true );
                    return true;
                }
                else{
                    this.$store.commit( 'setTopFiltersVisible', false );
                    this.$store.commit( 'teams/setCategorySelected', false );
                    return false;
                }
            },
            
            info_event_teams() {
                var aEvent = { ...this.$store.getters[ 'events/getCurrentEvent' ]() };
                var oCategories = { ...aEvent.categories };
                var aCategories = [];
                for( var k in oCategories ){
                    var category = oCategories[ k ];
                    aCategories.push( category );
                }
                return aCategories;
            },

            group_selected() {
                this.$store.commit( 'teams/setCategorySelected', false );
                return false;
            }
        },
        methods: {
            loadDataPage(){
                var page = this.page.replace( 'event_', '' );
                var oParams = {...this.$route.params};
                    oParams.event = this.$store.getters['events/getCurrentEvent']().id;

                this.on_submenu = ( typeof oParams.submenu !== 'undefined' )? oParams.submenu : false;
                var self = this
                this.$store.dispatch( page + '/loadList', oParams ).then( function(){
                    self.$overlay.hide()
                });
            },
            new_filters( filters ){
                this.$store.commit( this.page + '/applyFilters', filters );
            },

            top_filters( filters ){
                this.$store.commit( this.page + '/applyFilters', filters );
            },

            fnExport( type ){
                switch( type ){
                    case 'list': this.exportList();
                                break;
                }
            },

            exportList(){
                //TODO SHOW OVERLAY LOAD
                var sIDs = this.$refs.table.getIDsVisible();
                var aColumnsVisibles = this.$refs.table.getColumnsVisible();
                var page = this.$store.getters[ 'navigation/getCurrentPage' ].url.replace( '/', '' );

                return api.post( page + '/export/list', { headers: JSON.stringify( aColumnsVisibles ), data: sIDs } ).then( function( response ){
                    const link = document.createElement('a');
                    link.href = response.data.url;
                    link.setAttribute('download', 'calendar.xlsx');
                    document.body.appendChild(link);
                    link.click();
                });
            }
        },
        created() {
            this.loadDataPage();
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        max-width: 100% !important;

        .flex {
            // height: 500px;
            max-width: 100% !important;
            text-align: center;
            margin: 20px 0;
        
            img {
                // height: 100%;
                // object-position: center;
                // object-fit: contain;
            }
        }
    }
</style>